"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initDigitalFingerPrint = void 0;
var facct_1 = require("./facct");
var initDigitalFingerPrint = function (_a) {
    var _b = _a.environment, environment = _b === void 0 ? "prod" : _b, _c = _a.enabledVendors.facct, facct = _c === void 0 ? false : _c;
    if (facct) {
        (0, facct_1.initFacct)(environment);
    }
};
exports.initDigitalFingerPrint = initDigitalFingerPrint;
